<template>
  <div>
    <div class="tabs-container">
      <div class="tabs-content content">
        <div class="project--wrap">
          <template v-for="media in filteredMedia">
            <div
              v-if="media.type === 'video'"
              :key="media.id"
              class="project--column"
            >
              <div class="project--content">
                <div class="project--style project--style__info">
                  <div aria-hidden="true" class="position-relative d-flex">
                    <video
                      playsinline
                      :poster="media.thumbnail"
                      allowfullscreen
                      muted
                      controls
                      preload="none"
                      class="border-0 project--img project--media-video"
                      :class="{ played: playedVideos.includes(media.name) }"
                      @play="setPlayedVideo(media.name)"
                      :data-name="media.name"
                    >
                      <source :src="media.source" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="media.type === 'image'"
              :key="media.id"
              class="project--column"
            >
              <div
                v-scroll="handleScroll"
                data-scroll-class="animated zoomIn"
                data-scroll-button-distance="400"
                data-scroll-once="true"
                duration="5000"
              >
                <div class="project--content">
                  <div class="project--style project--style__info">
                    <div
                      aria-hidden="true"
                      class="project--style__container position-relative d-flex"
                    >
                      <img
                        :src="media.img"
                        class="project--img"
                        :alt="media.alt"
                      />
                      <div class="project--hover-content project--hover_mask">
                        <h5 class="project--item_title">
                          {{ media.captionTitle }}
                        </h5>
                        <p>{{ media.captionContent }}</p>
                        <hr class="xs-line" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="p-5 btn-outline--more">
      <div class="text-center">
        <button
          @click="shouldShowAll = !shouldShowAll"
          class="btn btn-outline__blue btn-white"
        >
          {{ shouldShowAll ? 'Ver menos' : 'Ver más' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gallery',
  props: {
    listImages: {
      type: Array,
      default: () => [],
    },
    listVideos: {
      type: Array,
      default: () => [],
    },
    listMedia: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    defaultQty: 6,
    previewQuantities: {
      mobile: 3,
      tablet: 4,
      desktop: 6,
    },
    shouldShowAll: false,
    showVideos: false,
    playedVideos: [],
  }),
  computed: {
    previewQty() {
      return this.previewQuantities[this.$mq] || this.defaultQty;
    },
    filteredImages() {
      return this.shouldShowAll
        ? this.listImages
        : this.listImages.slice(0, this.previewQty);
    },
    filteredMedia() {
      return this.shouldShowAll
        ? this.listMedia
        : this.listMedia.slice(0, this.previewQty);
    },
  },
  watch: {
    shouldShowAll(value) {
      setTimeout(() => {
        this.showVideos = value;
      }, 1000);
    },
  },
  methods: {
    setPlayedVideo(name) {
      if (this.playedVideos.includes(name)) {
        this.playedVideos = this.playedVideos.filter(video !== name);
      } else {
        this.playedVideos.push(name);
      }
    },
  },
};
</script>

<style lang="scss">
.default-tabs {
  position: relative;
  margin: 0 auto;

  &__item {
    display: inline-block;
    margin: 0 5px;
    padding: 10px;
    padding-bottom: 8px;
    font-size: 16px;
    letter-spacing: 0.8px;
    color: $gray;
    text-decoration: none;
    border: none;
    background-color: transparent;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.25s;

    &_active {
      color: $gray !important;
    }

    &:hover {
      border-bottom: 2px solid gray;
      color: $gray !important;
    }

    &:focus {
      outline: none;
      border-bottom: 2px solid gray;
      color: $gray !important;
    }

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &__active-line {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: $gray !important;
    transition: transform 0.4s ease, width 0.4s ease;
  }
}

.content {
  margin-top: 30px;
  font-size: 20px;
}

.project--wrap {
  display: flex;
  flex-wrap: wrap;

  .project--column {
    @extend %width__project;

    @media (max-width: 767px) {
      width: 50%;
    }

    @media (max-width: 549px) {
      width: 100%;
    }

    .project--content {
      position: relative;

      .project--style {
        position: relative;

        &__container {
          align-items: flex-start;
        }

        .project--media-video,
        .project--img {
          width: 100%;
          height: 24.21vw;
          background-color: black;

          &::focus {
            outline: 0;
          }

          @media (max-width: 767px) {
            height: 36.32vw;
          }

          @media (max-width: 549px) {
            height: 72.64vw;
          }

          @media (min-width: 768px) {
            &[data-name='texaco'].played {
              height: 22.8vw;
            }
          }
        }

        .project--img {
          @extend %width__project--img;
        }

        .project--hover-content {
          position: absolute;
          bottom: 0;
          text-align: center;
          color: $white;

          &:hover {
            transition: all 0.4s ease-out;
          }
        }

        .project--hover_mask {
          @extend %flex__align-bottom;
          @include bg-blue;
          flex-direction: column;
          justify-content: center;
          text-align: center;
          padding: 80px 60px;
          color: $white;
          opacity: 0;
          height: 100%;
          width: 100%;

          &:hover {
            opacity: 1;
          }

          i {
            font-size: $secondary-font-size;
            padding-bottom: 30px;
          }

          p {
            font-size: $extra-font-size;
            padding: 0 30px;
          }
        }
      }
    }
  }
}

.project--video {
  background-color: black;

  .project--column {
    .project--content {
      .project--style {
        .project--hover_mask {
          display: none;
        }
      }
    }
  }
}
</style>
